import { useEffect, useState } from "react";

import { useFieldMutation } from "../features/field-values/fieldValueApiSlice";
import { isRealLoanGuid } from "../utils/normalize-xml-for-create-loan";
import { ENCOMPASS_FIELD_IDS } from "../utils/aura.constants";
import { fieldValueMap } from "./useAuraInProgress";

// Reads ENHANCEDCOND.X1 for the loan ("Y" = Enhanced Conditions). AURA is offered only for
// enhanced loans; standard loans continue Without AURA. `checking` stays true until the read
// finishes, so callers don't disable anything on a guess.
const useIsEnhancedLoan = (loanGuid) => {
	const [readFields] = useFieldMutation();
	const [isEnhanced, setIsEnhanced] = useState(false);
	const [checking, setChecking] = useState(true);

	useEffect(() => {
		let active = true;
		if (!isRealLoanGuid(loanGuid)) {
			setChecking(false);
			return undefined;
		}
		setChecking(true);
		readFields({ loan_guid: loanGuid, fields: ENCOMPASS_FIELD_IDS.ENHANCED_CONDITIONS })
			.unwrap()
			.then((res) => {
				const value = fieldValueMap(res)[ENCOMPASS_FIELD_IDS.ENHANCED_CONDITIONS.toUpperCase()];
				if (active) setIsEnhanced(String(value || "").trim().toUpperCase() === "Y");
			})
			.catch(() => {
				if (active) setIsEnhanced(false);
			})
			.finally(() => {
				if (active) setChecking(false);
			});
		return () => {
			active = false;
		};
	}, [loanGuid, readFields]);

	return { isEnhanced, checking };
};

export default useIsEnhancedLoan;
